import React, { useState, useEffect } from "react";
import "./Header.css";
import { motion, AnimatePresence } from "framer-motion";
import { FaBars, FaTimes } from "react-icons/fa";
import { useLanguage } from "../../context/LanguageContext"; // 1. Import du Hook
import logoImg from "../../assets/logo.png";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  // 2. Récupération des outils de traduction
  const { language, toggleLanguage, t } = useLanguage();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // 3. Les titres viennent maintenant du fichier de traduction (t.header...)
  const menuItems = [
    { title: t.header.home, id: "hero" },
    { title: t.header.concept, id: "concept" },
    { title: t.header.services, id: "services" },
    { title: t.header.contact, id: "contact" },
  ];

  return (
    <nav className={`navbar ${isScrolled ? "scrolled" : ""}`}>
      <div className="navbar-container">
        {/* LOGO */}
        <div className="logo-container">
          <a href="#hero">
            <img src={logoImg} alt="OneTicket Logo" className="logo-img" />
          </a>
        </div>

        {/* MENU DESKTOP */}
        <div className="desktop-nav-wrapper">
          <ul className="nav-menu desktop-only">
            {menuItems.map((item) => (
              <li key={item.id} className="nav-item">
                <a href={`#${item.id}`} className="nav-link">
                  {item.title}
                </a>
              </li>
            ))}
          </ul>

          {/* 4. BOUTON LANGUE (Desktop) */}
          <button onClick={toggleLanguage} className="lang-btn desktop-only">
            {language === "fr" ? "EN" : "FR"}
          </button>
        </div>

        {/* BOUTON BURGER (Mobile) */}
        <div
          className="burger-icon mobile-only"
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
        >
          {mobileMenuOpen ? <FaTimes /> : <FaBars />}
        </div>
      </div>

      {/* MENU MOBILE (Overlay) */}
      <AnimatePresence>
        {mobileMenuOpen && (
          <motion.div
            className="mobile-menu-overlay"
            initial={{ x: "100%" }}
            animate={{ x: 0 }}
            exit={{ x: "100%" }}
            transition={{ type: "tween", duration: 0.3 }}
          >
            <ul className="mobile-menu-list">
              {menuItems.map((item) => (
                <li key={item.id} onClick={() => setMobileMenuOpen(false)}>
                  <a href={`#${item.id}`}>{item.title}</a>
                </li>
              ))}

              {/* 5. BOUTON LANGUE (Mobile) */}
              <li className="mobile-lang-item" onClick={toggleLanguage}>
                <span className="lang-switch-text">
                  {language === "fr"
                    ? "Switch to English 🇬🇧"
                    : "Passer en Français 🇫🇷"}
                </span>
              </li>
            </ul>
          </motion.div>
        )}
      </AnimatePresence>
    </nav>
  );
};

export default Header;
